export const commonTextFieldProps = {
  size: "small" as const,
  sx: {
    "& .MuiInputBase-input": { fontSize: "0.75rem" },
    "& .MuiInputLabel-root": { fontSize: "0.75rem" },
    "& .MuiMenuItem-root": { fontSize: "0.75rem" },
    "& .MuiFormHelperText-root": {
      fontSize: "0.65rem",
      mt: 0.5,
      mb: 0,
    },
  },
  SelectProps: {
    sx: {
      fontSize: "0.75rem",
      height: "34px",
    },
  },
};

export const commonDateFieldProps = {
  ...commonTextFieldProps,
  InputLabelProps: {
    shrink: true,
    sx: { fontSize: "0.75rem" },
  },
};

export const commonButtonProps = {
  size: "small" as const,
  sx: {
    "& .MuiButton-root": { fontSize: "0.75rem" },
    fontSize: "0.75rem",
    px: 2,
    py: 0.5,
  },
};

export const smallButtonProp = {
  size: "small" as const,
  sx: {
    "& .MuiButton-root": { fontSize: "0.75rem" },
    fontSize: "0.7rem",
    p: 0.5,
    lineHeight: "1.3",
  },
};

export const iconProps = {
  style: { fontSize: "0.75rem" },
};

export const smallButtonProps = {
  size: "small" as const,
  sx: {
    "& .MuiButton-root": { fontSize: "0.75rem" },
    px: 1,
    py: 0.25,
  },
};
export const commonTableContainerProps = {
  borderRadius: 1,
  border: "1px solid",
  borderColor: "grey.300",
  bgcolor: "#fdfdfd",
};
export const tableHeaderStyles = {
  backgroundcolor: "grey.50",
  fontWeight: "400",
  fontSize: "0.75rem",
  lineheight: "1.3",
};

export const tableRowStyles = {
  backgroundColor: "inherit",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
  "& .MuiTableCell-root": {
    borderBottom: "1px solid",
    borderColor: "grey.100",
  },
};
export const tableCellStyles = {
  fontSize: "0.75rem",
  lineheight: "1.3",
};

export const deletedTableRowStyles = {
  backgroundColor: "#fff5f5",
};

export const deletedTableHeaderStyles = {
  fontSize: "0.65rem",
  lineHeight: "1.3",
  fontStyle: "italic",
  color: "grey",
  border: "0.5px solid #e0e0e0",
};

export const deletedTableCellStyles = {
  fontSize: "0.65rem",
  lineHeight: "1.3",
  fontStyle: "italic",
  color: "grey",
  border: "0.5px solid #e0e0e0",
};

// rohit

export const deletedTableStyles = {
  fontSize: "0.55rem",
  border: "1px solid #e0e0e0",
};

export const bookingDetailsHeaderStyles = {
  fontSize: "0.65rem",
};

export const bookingDetailsCellStyles = {
  fontSize: "0.65rem",
};

export const commonTypographyProps = {
  fontSize: "0.75rem",
};

export const tabStyles = {
  fontSize: "0.75rem",
  fontWeight: "500",
  padding: "6px 12px",
};
